var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container text-center mb-5"},[_c('h3',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.titulo_principal))])]),_c('tabla-simple',{staticClass:"mt-5",attrs:{"id":"tablaCPRB","titulo":_vm.data.text,"datos":_vm.data}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.fecha_actualizacion)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }